module.exports = __webpack_public_path__ + "assets/9e9fd0088ce375ad68de80eaf6d76c89.mp4";